<nav class="pc-sidebar">
  <div class="navbar-wrapper">
    <div class="header-top">
      <!-- Alleen het beeldmerk. Het volledige logo bevat naast de naam ook
           een klein onderschrift; dat moest zo ver verkleind worden om in de
           balk te passen dat het merk zelf nog maar een paar tellen groot was.
           Los getekend kan het beeldmerk ruim twee keer zo groot staan en
           blijft het herkenbaar. De naam staat al in de titel van het
           tabblad, dus er gaat niets verloren. -->
      <img src="assets/images/playstats-glyph.svg" alt="PlayStats" class="logo">

      <!-- Twee knoppen die allebei ruimte teruggeven, dus horen ze bij
           elkaar: de ene haalt de zijbalk weg, de andere de browserbalk. -->
      <div class="kop-knoppen">
        <!-- Schermvullend. Chrome's adresbalk, tabbladen en bladwijzers kosten
             samen zo'n 120px bovenaan; op een scherm waar je een wedstrijd
             lang naar kijkt is dat een hele tabelrij. F11 doet hetzelfde, maar
             die moet je weten -- een knop staat er gewoon. -->
        <button type="button"
                class="zijbalk-schakelaar"
                (click)="wisselSchermvullend()"
                [attr.aria-pressed]="schermvullend"
                [title]="schermvullend ? 'Leave fullscreen (Esc)' : 'Fullscreen (F11)'">
          <i class="bi" [ngClass]="schermvullend ? 'bi-fullscreen-exit' : 'bi-arrows-fullscreen'"></i>
        </button>

        <!-- In- en uitklappen. Ingeklapt blijft alleen de pictogrammenstrook
             over (72px i.p.v. 280px), wat ruim 200px teruggeeft aan de pagina
             ernaast - genoeg om het vlootoverzicht met zijn tien kolommen
             zonder horizontaal schuiven te lezen. -->
        <button type="button"
                class="zijbalk-schakelaar"
                (click)="wisselZijbalk()"
                [attr.aria-expanded]="!ingeklapt"
                aria-controls="zijbalk-menu"
                [title]="ingeklapt ? 'Menu uitklappen' : 'Menu inklappen'">
          <i class="bi" [ngClass]="ingeklapt ? 'bi-chevron-double-right' : 'bi-chevron-double-left'"></i>
        </button>
      </div>
    </div>

    <div class="navbar-content" id="zijbalk-menu">
      <ul class="sidebar-navbar">
        <li class="item">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [title]="ingeklapt ? 'Dashboard' : null">
            <span class="nav-icon">
              <i class="bi bi-house"></i>
            </span>
            <span class="nav-text">Dashboard</span>
          </a>
        </li>
        <li class="kopje" role="presentation">Organisation</li>
        <li class="item">
          <a class="nav-link" routerLink="/clubs" routerLinkActive="active" [title]="ingeklapt ? 'Clubs' : null">
            <span class="nav-icon">
              <i class="bi bi-shield"></i>
            </span>
            <span class="nav-text">Clubs</span>
          </a>
        </li>
        <li class="item" *ngIf="superAdmin">
          <a class="nav-link" routerLink="/club-requests" routerLinkActive="active"
             [title]="ingeklapt ? 'Club requests' + (aanvragen() ? ' (' + aanvragen() + ')' : '') : null">
            <span class="nav-icon">
              <i class="bi bi-inbox"></i>
            </span>
            <span class="nav-text">Club requests</span>
            <span class="menu-teller" *ngIf="aanvragen() > 0" [attr.aria-label]="aanvragen() + ' pending'">{{ aanvragen() }}</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/leagues" routerLinkActive="active" [title]="ingeklapt ? 'Leagues' : null">
            <span class="nav-icon">
              <i class="bi bi-trophy"></i>
            </span>
            <span class="nav-text">Leagues</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/federations" routerLinkActive="active" [title]="ingeklapt ? 'Federations' : null">
            <span class="nav-icon">
              <i class="bi bi-diagram-3"></i>
            </span>
            <span class="nav-text">Federations</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/licences" routerLinkActive="active" [title]="ingeklapt ? 'Licences' : null">
            <span class="nav-icon">
              <i class="bi bi-key"></i>
            </span>
            <span class="nav-text">Licences</span>
          </a>
        </li>
        <!-- Wat nieuwe gebruikers na de welkomstvragen zien (docs/ONBOARDING.md). -->
        <li class="item" *ngIf="superAdmin">
          <a class="nav-link" routerLink="/onboarding" routerLinkActive="active" [title]="ingeklapt ? 'Onboarding' : null">
            <span class="nav-icon">
              <i class="bi bi-signpost-2"></i>
            </span>
            <span class="nav-text">Onboarding</span>
          </a>
        </li>
        <li class="kopje" role="presentation">People</li>
        <!-- Aanvragen vanaf het inlogscherm (22-10-2026), met datum en tijd. -->
        <li class="item" *ngIf="superAdmin">
          <a class="nav-link" routerLink="/account-requests" routerLinkActive="active"
             [title]="ingeklapt ? 'Account requests' + (accountAanvragen() ? ' (' + accountAanvragen() + ')' : '') : null">
            <span class="nav-icon">
              <i class="bi bi-person-plus"></i>
            </span>
            <span class="nav-text">Account requests</span>
            <span class="menu-teller" *ngIf="accountAanvragen() > 0" [attr.aria-label]="accountAanvragen() + ' pending'">{{ accountAanvragen() }}</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/users" routerLinkActive="active" [title]="ingeklapt ? 'Users' : null">
            <span class="nav-icon">
              <i class="bi bi-people"></i>
            </span>
            <span class="nav-text">Users</span>
          </a>
        </li>
        <!-- Wie het platform gebruikt, per club en per persoon (eigenaar
             15-10-2026: "welke clubs er het meest gebruik van maken, en
             inzoomen binnen de club"). Onder People: het gaat over mensen. -->
        <li class="item">
          <a class="nav-link" routerLink="/platform-usage" routerLinkActive="active" [title]="ingeklapt ? 'Platform usage' : null">
            <span class="nav-icon">
              <i class="bi bi-activity"></i>
            </span>
            <span class="nav-text">Platform usage</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/roles" routerLinkActive="active" [title]="ingeklapt ? 'Roles' : null">
            <span class="nav-icon">
              <i class="bi bi-person-lock"></i>
            </span>
            <span class="nav-text">Roles</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/players" routerLinkActive="active" [title]="ingeklapt ? 'Players' : null">
            <span class="nav-icon">
              <i class="bi bi-person"></i>
            </span>
            <span class="nav-text">Players</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/global-players" routerLinkActive="active" [title]="ingeklapt ? 'Global players' : null">
            <span class="nav-icon">
              <i class="bi bi-person-badge"></i>
            </span>
            <span class="nav-text">Global players</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/teams" routerLinkActive="active" [title]="ingeklapt ? 'Teams' : null">
            <span class="nav-icon">
              <i class="bi bi-people"></i>
            </span>
            <span class="nav-text">Teams</span>
          </a>
        </li>
        <li class="kopje" role="presentation">Matches &amp; video</li>
        <li class="item">
          <a class="nav-link" routerLink="/matches" routerLinkActive="active" [title]="ingeklapt ? 'Matches' : null">
            <span class="nav-icon">
              <i class="bi bi-calendar-event"></i>
            </span>
            <span class="nav-text">Matches</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/videos" routerLinkActive="active" [title]="ingeklapt ? 'Videos' : null">
            <span class="nav-icon">
              <i class="bi bi-camera-video"></i>
            </span>
            <span class="nav-text">Videos</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/schedules" routerLinkActive="active" [title]="ingeklapt ? 'Schedules' : null">
            <span class="nav-icon">
              <i class="bi bi-calendar-event"></i>
            </span>
            <span class="nav-text">Schedules</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/panels" [ngClass]="{'active': isRouteActive('/panels/club', true) || isRouteActive('/panels/global')}" [title]="ingeklapt ? 'Panels' : null">
            <span class="nav-icon">
              <i class="bi bi-grid-1x2"></i>
            </span>
            <span class="nav-text">Panels</span>
            <span class="nav-arrow" routerLinkActive="active">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </span>
          </a>
          <ul class="sidebar-subnav" *ngIf="isRouteActive('/panels/club', true) || isRouteActive('/panels/global')">
            <li class="item"><a class="nav-link" routerLink="/panels/club" routerLinkActive="active">Club Panels</a></li>
            <li class="item"><a class="nav-link" routerLink="/panels/global" routerLinkActive="active">Global Panels</a></li>
          </ul>
        </li>
        <li class="kopje" role="presentation">Data</li>
        <li class="item">
          <a class="nav-link" routerLink="/integrations/incoming" routerLinkActive="active" [title]="ingeklapt ? 'Incoming integrations' : null">
            <span class="nav-icon">
              <i class="bi bi-box-arrow-in-down"></i>
            </span>
            <span class="nav-text">Incoming</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/integrations/outgoing" routerLinkActive="active" [title]="ingeklapt ? 'Outgoing integrations' : null">
            <span class="nav-icon">
              <i class="bi bi-box-arrow-up"></i>
            </span>
            <span class="nav-text">Outgoing</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/data-imports" routerLinkActive="active" [title]="ingeklapt ? 'Data imports' : null">
            <span class="nav-icon">
              <i class="bi bi-file-earmark-check"></i>
            </span>
            <span class="nav-text">Data imports</span>
          </a>
        </li>
        <li class="item" *ngIf="superAdmin">
          <a class="nav-link" routerLink="/club-catalog" routerLinkActive="active" [title]="ingeklapt ? 'Club catalog' : null">
            <span class="nav-icon">
              <i class="bi bi-table"></i>
            </span>
            <span class="nav-text">Club catalog</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/tagging-teams" routerLinkActive="active" [title]="ingeklapt ? 'Tagging teams' : null">
            <span class="nav-icon">
              <i class="bi bi-tags"></i>
            </span>
            <span class="nav-text">Tagging teams</span>
          </a>
        </li>
        <li class="kopje" role="presentation">Hardware</li>
        <li class="item">
          <a class="nav-link" routerLink="/fleet" routerLinkActive="active" [title]="ingeklapt ? 'Fleet' : null">
            <span class="nav-icon">
              <i class="bi bi-pc-display"></i>
            </span>
            <span class="nav-text">Fleet</span>
          </a>
        </li>
        <!-- SportCam Go (Raying): PlayStats is de backend van de camera,
             zie docs/SPORTCAM-GO.md. Hardware zoals Fleet, maar geen pc. -->
        <li class="item">
          <a class="nav-link" routerLink="/sportcam" routerLinkActive="active" [title]="ingeklapt ? 'SportCam Go' : null">
            <span class="nav-icon">
              <i class="bi bi-webcam"></i>
            </span>
            <span class="nav-text">SportCam Go</span>
          </a>
        </li>
        <!-- Wie de studio's gebruikt, wat en vanwaar, per club (eigenaar
             13-10-2026: "zodat we inzage hebben in hoeveel clubs het
             gebruiken"). Onder Fleet: zelfde vloot, maar over mensen in
             plaats van over pc's. -->
        <li class="item">
          <a class="nav-link" routerLink="/studio-usage" routerLinkActive="active" [title]="ingeklapt ? 'Studio usage' : null">
            <span class="nav-icon">
              <i class="bi bi-people"></i>
            </span>
            <span class="nav-text">Studio usage</span>
          </a>
        </li>
        <!-- Staat DIRECT onder Fleet, want je komt hier altijd vanuit die
             lijst: Fleet zegt welke pc een probleem heeft, dit scherm zegt
             wat er mis is. De pagina bestond al maanden (/studio en
             /studio/:clubId, met engineLive, renderFps, gpuMemPct en de
             ketenmeldingen per camera) maar stond in geen enkel menu -- je
             kon er alleen komen door de URL in te typen, dus niemand vond
             hem (01-09-2026).

             Heet "Monitoring" en niet "Studio": een studio is een pc bij een
             club, en dat zei niets over wat je hier komt doen. Dat woord kwam
             vrij toen de oude Monitoring-pagina "Usage" werd -- die ging over
             kijktijd, niet over of het systeem het doet.

             LET OP bij het lezen van URL's: /studio toont nu "Monitoring" en
             /monitoring toont "Usage". De routes staan in bladwijzers en in
             links die al rondgestuurd zijn, dus die zijn met opzet blijven
             staan; een knop hernoemen is iets anders dan een adres omleggen. -->
        <li class="item">
          <a class="nav-link" routerLink="/studio" routerLinkActive="active" [title]="ingeklapt ? 'Monitoring' : null">
            <span class="nav-icon">
              <i class="bi bi-broadcast"></i>
            </span>
            <span class="nav-text">Monitoring</span>
          </a>
        </li>
        <!-- Clubstats vat samen wat Monitoring per pc toont, maar dan per CLUB:
             hoeveel en welke camera's beeld sturen, wie er nu live opneemt,
             waar de schijf knelt en wie de opnames plant. Staat naast
             Monitoring omdat het dezelfde vloot-bron leest, een niveau hoger. -->
        <li class="item">
          <a class="nav-link" routerLink="/clubs-stats" routerLinkActive="active" [title]="ingeklapt ? 'Clubstats' : null">
            <span class="nav-icon">
              <i class="bi bi-camera-video"></i>
            </span>
            <span class="nav-text">Clubstats</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/recorders" routerLinkActive="active" [title]="ingeklapt ? 'Recorders' : null">
            <span class="nav-icon">
              <i class="bi bi-record-circle"></i>
            </span>
            <span class="nav-text">Recorders</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/producers" routerLinkActive="active" [title]="ingeklapt ? 'Producers' : null">
            <span class="nav-icon">
              <i class="bi bi-camera-reels"></i>
            </span>
            <span class="nav-text">Producers</span>
          </a>
        </li>
        <li class="kopje" role="presentation">Insights</li>
        <!-- Cijfers voor een salesgesprek (15-10-2026); dezelfde pagina die
             de rol sales_viewer als enige ziet. -->
        <li class="item">
          <a class="nav-link" routerLink="/numbers" routerLinkActive="active" [title]="ingeklapt ? 'Numbers' : null">
            <span class="nav-icon">
              <i class="bi bi-bar-chart-line"></i>
            </span>
            <span class="nav-text">Numbers</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/monitoring" routerLinkActive="active" [title]="ingeklapt ? 'Usage' : null">
            <span class="nav-icon">
              <i class="bi bi-graph-up"></i>
            </span>
            <span class="nav-text">Usage</span>
          </a>
        </li>
        <li class="item">
          <a class="nav-link" routerLink="/tracking" routerLinkActive="active" [title]="ingeklapt ? 'Tracking' : null">
            <span class="nav-icon">
              <i class="bi bi-bullseye"></i>
            </span>
            <span class="nav-text">Tracking</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Het account onderaan de zijbalk. Dit stond in een eigen balk over de
         volle breedte boven elke pagina, die verder helemaal leeg was: 70
         pixels hoogte op elk scherm voor één naam. Onderin de zijbalk kost
         het geen aparte strook, en het is de gebruikelijke plek. -->
    <div class="sidebar-account" *ngIf="user" dropdown [dropup]="true">
      <a class="account-link" dropdownToggle id="button-account"
         [title]="ingeklapt ? user.firstName + ' ' + user.lastName : null">
        <span class="account-initialen">{{ initialen }}</span>
        <span class="account-naam">
          <span class="naam">{{ user.firstName }} {{ user.lastName }}</span>
          <span class="rol">Administrator</span>
        </span>
        <i class="bi bi-three-dots"></i>
      </a>
      <ul id="dropdown-account" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-account">
        <li role="menuitem"><a class="dropdown-item" routerLink="/security">Beveiliging</a></li>
        <li role="menuitem"><a class="dropdown-item" href="#" (click)="onLogOut()">Log out</a></li>
      </ul>
    </div>
  </div>
</nav>
